// Coming back to /cart via the browser's back button (e.g. from checkout) can restore the
// page from bfcache instead of reloading it, leaving the page working with a stale cart/session
// reference. That's what was causing /cart/change to fail with a 400 and desync the UI. Forcing
// a real reload when the page is restored from bfcache guarantees the cart state is current.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      init() {
        this.itemsRoot = this.$root;

        window.addEventListener('shapes:modalcart:afteradditem', (e) => {
          const itemsHtml = e.detail.response?.sections?.['cart-items'];
          if (!itemsHtml) return;
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString('[data-cart-items]', itemsHtml).outerHTML
          );
        });

        window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
          const itemsHtml = e.detail.response?.sections?.['cart-items'];
          if (!itemsHtml) return;
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString('[data-cart-items]', itemsHtml).outerHTML
          );

          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        let maxItemsToBuy = null;
        let itemsQuantity = null;

        const maxItemsToBuyElement = document.querySelector(
          '.cart__contents[data-max-product-in-cart]'
        );

        const allItemsInCart = document.querySelectorAll(
          '.cart__contents .cart-item-quantity-value'
        );

        if (allItemsInCart && maxItemsToBuyElement) {
          itemsQuantity = Array.from(allItemsInCart).reduce(
            (acc, curr) => acc + Number(curr.value),
            0
          );

          maxItemsToBuy = Number(
            maxItemsToBuyElement.getAttribute('data-max-product-in-cart')
          );

          if (itemsQuantity >= maxItemsToBuy) {
            const increseButtons = document.querySelectorAll(
              '.cart__contents button[aria-label="+"]'
            );
            if (increseButtons.length > 0) {
              increseButtons.forEach((button) => {
                if (!button.hasAttribute('disabled')) {
                  button.setAttribute('disabled', true);
                }
              });
            }
          }
        }

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');

        let id = key ? key : lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10),
          sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

        const config = fetchConfigDefaults('javascript');

        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (itemsQuantity > maxItemsToBuy) {
          quantity = lastValue;
          this.$el.value = lastValue;

          const allItemsInCart = document.querySelectorAll(
            '.cart__contents .cart-item-quantity-value'
          );

          const newItemsQuantity = Array.from(allItemsInCart).reduce(
            (acc, curr) => acc + Number(curr.value),
            0
          );

          const subtraction = maxItemsToBuy - newItemsQuantity;

          if (subtraction > 0) {
            quantity = subtraction + lastValue;
            this.$el.value = subtraction + lastValue;
          }
        }

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          this.locked = lineItemEl;

          fetch(theme.routes.cart_change_url, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422 || !data.sections) {
                const errorEl = lineItemEl.querySelector(
                  '[data-cart-quantity-error]'
                );

                if (errorEl) {
                  errorEl.textContent = data.message || theme.strings.cartError;
                }

                // errorEl.style.display = '';
                lineItemEl.classList.remove('opacity-50', 'cursor-progress');

                this.$el.value = lastValue;

                if (!data.sections) {
                  // Not a normal 422 validation error (which still returns sections)
                  // but something unexpected, e.g. a stale cart after returning from
                  // checkout via the back button. The client-side state can no longer
                  // be trusted at that point, so reload for a clean, current cart
                  // instead of risking the UI silently drifting out of sync.
                  window.location.reload();
                }
              } else {
                document.body.dispatchEvent(
                  new CustomEvent('shapes:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                );

                // Trust the server-computed decision (rosoły 3-6-9 rule + zupy minimum + terms
                // checkbox), shared with cart-footer.js so this never drifts out of sync.
                window.applyCartCheckoutButtonDisabledState?.();
              }
            })
            .catch(() => {
              document.getElementById('cart-errors').textContent =
                theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            newValue = lastValue - 1;
          } else {
            newValue = 1;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
